module.exports = __webpack_public_path__ + "static/media/30-11.c1e31fda.mp3";